export const money = (n: number) => "$" + Number(n).toLocaleString("en-CA");

export const bedLabel = (beds: number) => (beds === 0 ? "Studio" : `${beds} bd`);

export const cap = (s: string) => String(s).charAt(0).toUpperCase() + String(s).slice(1);

export const num = (n: number) => n.toLocaleString("en-CA");

export function fmtDate(iso: string): string {
  const d = new Date(iso + "T00:00:00Z");
  return Number.isNaN(d.getTime())
    ? iso
    : d.toLocaleDateString("en-CA", { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" });
}

export const imageUrl = (id: string, width: number) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${width}&q=70`;
